import React, { Component } from "react";
import { Col } from "reactstrap";
import NewsItem from "./NewsItem";
import AkteItem from "./AktItem";
class SearchItem extends Component {
  componentWillMount = () => {};
  getItems = () => {
    let data = this.props.result;
    if (data.titulli || data.titulli == null) {
      return <NewsItem data={data} />;
    } else {
      return <AkteItem data={data} />;
    }
  };
  render() {
    return <Col sm={12}>{this.props.result.titulli}</Col>;
  }
}
export default SearchItem;
